import { ErrorMessage, Field } from 'formik';
import { Col, Form, FormControl, Row } from 'react-bootstrap';
import { FormLabel, FormStepHeader, RequiredIndicator } from '../../../../../components/forms';
import { genderOptions, gradeLevelOptions, pickupOptions } from '../../../../../utils/consts';
import { StepProps } from './AddEditChild';

export const ChildForm = ({ touched, errors, readOnly }: StepProps) => {
  return (
    <>
      <Row>
        <Col xs={12}>
          <FormStepHeader
            title="Child Details"
            showRequiredLegend={!readOnly}
          />
        </Col>
      </Row>
      <Row>
        <Col
          xs={12}
          lg={6}
          className="pe-1"
        >
          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="first_name"
          >
            <FormLabel required>First Name</FormLabel>
            <Field
              name="first_name"
              type="text"
              as={Form.Control}
              isInvalid={touched.first_name && !!errors.first_name}
              aria-required
            />
            <ErrorMessage name="first_name">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="last_name"
          >
            <FormLabel required>Last Name</FormLabel>
            <Field
              name="last_name"
              type="text"
              as={Form.Control}
              isInvalid={touched.last_name && !!errors.last_name}
              aria-required
            />
            <ErrorMessage name="last_name">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="dob"
          >
            <FormLabel>Date of Birth</FormLabel>
            <Field
              name="dob"
              type="text"
              as={Form.Control}
              isInvalid={touched.dob && !!errors.dob}
            />
            <ErrorMessage name="dob">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="grade_level"
          >
            <FormLabel required>Grade</FormLabel>
            <Field
              name="grade_level"
              as={Form.Select}
              isInvalid={touched.grade_level && !!errors.grade_level}
              aria-required
            >
              <option>Select</option>
              {gradeLevelOptions.map((opt, idx) => (
                <option
                  key={idx}
                  value={opt}
                >
                  {opt}
                </option>
              ))}
            </Field>
            <ErrorMessage name="grade_level">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="gender"
          >
            <FormLabel required>Gender</FormLabel>
            <Field
              name="gender"
              as={Form.Select}
              isInvalid={touched.gender && !!errors.gender}
              aria-required
            >
              <option>Select</option>
              {genderOptions.map((opt, idx) => (
                <option
                  key={idx}
                  value={opt.value}
                >
                  {opt.name}
                </option>
              ))}
            </Field>
            <ErrorMessage name="gender">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="emotional_needs"
          >
            <FormLabel>Emotional Needs</FormLabel>
            <Field
              name="emotional_needs"
              as="textarea"
              rows={3}
              className="form-control"
            />
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="parent_guardian"
          >
            <FormLabel>Parent Guardian</FormLabel>
            <Field
              name="parent_guardian"
              as="textarea"
              rows={3}
              className="form-control"
            />
          </Form.Group>
        </Col>

        <Col
          xs={12}
          lg={6}
          className="pe-1"
        >
          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="emergency_contacts"
          >
            <FormLabel>Emergency Contacts</FormLabel>
            <Field
              name="emergency_contacts"
              as="textarea"
              rows={4}
              className="form-control"
            />
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="pickup_type"
          >
            <FormLabel>Pickup Type</FormLabel>
            <Field
              name="pickup_type"
              as={Form.Select}
              isInvalid={touched.pickup_type && !!errors.pickup_type}
            >
              <option>Select</option>
              {pickupOptions.map((opt, idx) => (
                <option
                  key={idx}
                  value={opt}
                >
                  {opt}
                </option>
              ))}
            </Field>
            <ErrorMessage name="pickup_type">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="pickup_other"
          >
            <FormLabel>Pickup Other</FormLabel>
            <Field
              name="pickup_other"
              as="textarea"
              rows={3}
              className="form-control"
            />
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="origination"
          >
            <FormLabel>Teacher/Classroom</FormLabel>
            <Field
              name="origination"
              as="textarea"
              rows={3}
              className="form-control"
            />
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="social_emotional_needs"
          >
            <FormLabel>Social Emotional Needs</FormLabel>
            <Field
              name="social_emotional_needs"
              as="textarea"
              rows={3}
              className="form-control"
            />
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="agree_to_terms"
          >
            <Form.Label>
              <Field
                name="agree_to_terms"
                type="checkbox"
                as={Form.Check}
                label={
                  <>
                    Agree to terms
                    <RequiredIndicator />
                  </>
                }
                isInvalid={touched.agree_to_terms && !!errors.agree_to_terms}
                aria-required
              />
            </Form.Label>
            <ErrorMessage name="agree_to_terms">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};
